/* eslint no-unused-vars: 0 */
import React, { Component } from 'react';
import { Map } from 'immutable';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as Actions from '../actions/actions';

import * as EventHandler from '../services/EventHandler';

import { StepOrder } from '../constants/Steps';

export class NavigationControl extends Component {
    handleFormSubmit(handler) {
        if (!this.props.canSubmit) {
            return;
        }

        handler();
    }

    goBack() {
        browserHistory.goBack();
    }

    submitData() {
        this.props.actions.submit(this.props.person.getDataAsJSON(), 'finish');
        EventHandler.track('Clicked Send Message', {
            category: 'Message page',
        });
    }

    /* eslint indent: 0 */
    renderForwardButton() {
        let text;
        let handleActionFunction;

        switch (this.props.stepIndex) {
            case StepOrder.SEND_MESSAGE:
                text = 'Send';
                handleActionFunction = this.submitData;
                break;
            default:
                return '';
        }

        return (
            <button className="big-button vouchedfor-brand" refs="next" name="next"
                    onClick={ this.handleFormSubmit.bind(this, handleActionFunction.bind(this)) }>
                { text }
            </button>
        );
    }

    renderSecondaryButton() {
        if (this.props.stepIndex >= StepOrder.SEND_MESSAGE && this.props.stepIndex < StepOrder.FINISH) {
            return (
                <button className="big-button back vouchedfor-brand"
                        onClick={ this.goBack.bind(this) } type="button">
                    Previous
                </button>
            );
        }

        return null;
    }

    renderRequiredNotification() {
        if (!this.props.invalidSubmit) {
            return null;
        }

        const requiredMessage = 'Please fill the required fields or delete any you don\'t want to include';
        return <div className="app__page-error small">{ requiredMessage }</div>;
    }

    render() {
        // Don't render if < 0 or 'null' or 'undefined'
        /* eslint eqeqeq: 0 */
        if (this.props.stepIndex < 0 || this.props.stepIndex == null || this.props.stepIndex === StepOrder.FINISH) {
            return <div></div>;
        }

        return (
            <section className="app__main-section app__main-section__actions--alignment">
                <div className="app__main-section__actions">
                    { this.renderSecondaryButton() }
                    { this.renderForwardButton() }
                    { this.renderRequiredNotification() }
                </div>
                {
                    this.props.stepIndex === StepOrder.SEND_MESSAGE &&
                    <div className="contact-link push-down-50 push-up-30">
                        Not ready to contact anyone yet? Give us a call on <a href="tel:02031110583">0203 111 0583</a>
                    </div>
                }
            </section>
        );
    }
}

NavigationControl.propTypes = {
    person: React.PropTypes.object,
    stepIndex: React.PropTypes.number,
    actions: React.PropTypes.object,

    canSubmit: React.PropTypes.bool,
    invalidSubmit: React.PropTypes.bool,
};

function mapStateToProps(state) {
    return {
        person: state.reducer.get('person'),

        stepIndex: state.navigation.get('stepIndex'),
        title: state.navigation.get('title'),

        canSubmit: state.navigation.get('canSubmit'),
        invalidSubmit: state.navigation.get('invalidSubmit'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NavigationControl);



// WEBPACK FOOTER //
// ./src/components/NavigationControl.jsx